import { render, staticRenderFns } from "./userlike-chat-button.vue?vue&type=template&id=f13573a4&"
import script from "./userlike-chat-button.vue?vue&type=script&lang=js&"
export * from "./userlike-chat-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports